export default __webpack_public_path__ + "static/Seo logo-e1d298151dc0ea9367fe6cff8ba57647.png";